import { render, staticRenderFns } from "./VolumeBuyersHeader.vue?vue&type=template&id=77f441ea&"
import script from "./VolumeBuyersHeader.vue?vue&type=script&lang=ts&"
export * from "./VolumeBuyersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VolumeBuyersHeader.vue?vue&type=style&index=0&id=77f441ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports